// useAuth hook com suporte a socket
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import api from "../../services/api";
import { socketConnection } from "../../services/socket";

// Fix 2026-08-19: conta dedicada da TV (nao e' uma pessoa de verdade,
// e' o login que fica logado sozinho no navegador da TV) - sempre deve
// cair direto no Painel TV, tanto num login novo quanto ao recarregar a
// pagina com um token ja salvo (a TV pode ficar dias sem alguem
// interagir, so' recarregando via refresh_token).
const TV_ACCOUNT_EMAIL = "naoresponda@gruporrstrike.com.br";

const useAuth = () => {
  const history = useHistory();
  const theme = useTheme();
  const [isAuth, setIsAuth] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({});
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && token !== "null") {
      try {
        const parsedToken = JSON.parse(token);
        api.defaults.headers.common["Authorization"] = "Bearer " + parsedToken;

        api.post("/auth/refresh_token")
          .then((res) => {
            setUser(res.data.user);
            const newSocket = socketConnection({ user: res.data.user });
            setSocket(newSocket);
            setIsAuth(true);
            setLoading(false);
            if (res.data.user?.email === TV_ACCOUNT_EMAIL) {
              if (window.location.pathname !== "/painel-tv") {
                history.push("/painel-tv");
              }
            } else if (window.location.pathname === "/" || window.location.pathname === "/login") {
              history.push("/tickets");
            }
          })
          .catch(() => {
            localStorage.clear();
            api.defaults.headers.common["Authorization"] = undefined;
            setIsAuth(false);
            setLoading(false);
            history.push("/login");
          });
      } catch (err) {
        localStorage.clear();
        setLoading(false);
        history.push("/login");
      }
    } else {
      setLoading(false);
      if (window.location.pathname !== "/login") {
        history.push("/login");
      }
    }
  }, [history]);

  const handleLogin = (userData) => {
    localStorage.setItem("token", JSON.stringify(userData.token));
    localStorage.setItem("companyId", userData.companyId);
    api.defaults.headers.common["Authorization"] = "Bearer " + userData.token;
    setUser(userData.user);
    const newSocket = socketConnection({ user: userData.user });
    setSocket(newSocket);
    setIsAuth(true);
    const volume = +(localStorage.getItem("volume") || 1);
    if (volume > 0 && theme.soundLogin) {
      new Audio(theme.soundLogin).play().catch(() => {});
    }
    if (userData.user?.email === TV_ACCOUNT_EMAIL) {
      history.push("/painel-tv");
    } else {
      // Fix 2026-09-21: volta pra pagina que o usuario tentou acessar
      // antes de ser jogado pro /login (guardada em location.state.from
      // pelo <Route isPrivate>), em vez de sempre cair em /tickets -
      // e' o que fazia /senha-tecnica "perder" o destino apos logar.
      const redirectPath = history.location.state?.from?.pathname;
      history.push(redirectPath && redirectPath !== "/login" ? redirectPath : "/tickets");
    }
  };

  // Fix 2026-10-23 (reportado pelo usuario: admin mudou as permissoes
  // do Luca - Sobreaviso liberado, Comercial retirado - e nada mudou
  // pra ele na hora, continuou vendo o estado antigo). user.permissions
  // (e os outros campos allowX/layoutPreference/etc) so' eram
  // recarregados no login/refresh_token (SerializeUser.ts) - um admin
  // salvando em UserController.update ja' emitia
  // `company-{id}-user` com o usuario atualizado (so' a tela de Usuarios
  // escutava, pra atualizar a listagem de quem esta editando), mas quem
  // estava LOGADO COMO o proprio usuario editado nunca recebia a
  // atualizacao - precisava deslogar e logar de novo. Agora, se o
  // evento for sobre o proprio usuario da sessao, funde os campos novos
  // no estado local sem precisar de reload nem logout.
  useEffect(() => {
    if (!socket || !user?.id || !user?.companyId) return undefined;
    const companyId = user.companyId;
    const onCompanyUserSelfUpdate = (data) => {
      if (data.action === "update" && data.user?.id === user.id) {
        setUser((prev) => ({ ...prev, ...data.user, token: prev.token }));
      }
    };
    socket.on(`company-${companyId}-user`, onCompanyUserSelfUpdate);
    return () => {
      socket.off(`company-${companyId}-user`, onCompanyUserSelfUpdate);
    };
  }, [socket, user?.id, user?.companyId]);

  const handleLogout = () => {
    setIsAuth(false);
    setUser({});
    localStorage.clear();
    if (socket) {
      socket.disconnect();
    }
    setSocket(null);
    api.defaults.headers.common["Authorization"] = undefined;
    history.push("/login");
  };

  return { isAuth, user, loading, handleLogin, handleLogout, socket };
};

export default useAuth;
